module.exports = __webpack_public_path__ + "static/media/Login-ideal-Logo@2x.26ceefbb.png";